"use client"

import { useEffect } from "react"

/**
 * PWA Service Worker Registration
 * 
 * Registers the service worker for offline support and caching.
 * Only runs in production and when service workers are supported.
 */
export function PWARegister() {
  useEffect(() => {
    // Only register in production
    if (process.env.NODE_ENV !== "production") {
      return
    }

    // Check if service workers are supported
    if (typeof window !== "undefined" && "serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/sw.js")
        .then((registration) => {
          console.log("Service Worker registered:", registration.scope)

          // Check for updates periodically
          setInterval(() => {
            registration.update()
          }, 60000) // Check every minute
        })
        .catch((error) => {
          console.error("Service Worker registration failed:", error)
        })
    }
  }, [])

  return null
}

